import { Login } from 'Pages/Login'
import { ReminderList } from 'Components/User/ReminderList'
import { Box, Typography } from '@mui/material'
import { useAccountId } from 'ContextProviders/CurrentAccount'

export function AboutPage (): JSX.Element {
  return <>
    <Typography variant="h3" data-testid='homepageLabel'>{useAccountId()?.type} Home</Typography>
    <Box sx={{ marginTop: '10px' }}>
      <Login />
    </Box>
    <Box sx={{ marginTop: '15px' }}>
      <ReminderList />
    </Box>
  </>
}
